var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=location, strong=no, disabled=yes, subdimension=no"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H12C14.2091 16 16 14.2091 16 12V4C16 1.79086 14.2091 0 12 0H4Z",
    fill: "#5F6877"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13C8 13 11.75 9.44607 11.75 6.75C11.75 4.67893 10.0711 3 8 3C5.92893 3 4.25 4.67893 4.25 6.75C4.25 9.44607 8 13 8 13ZM8 8.625C6.96447 8.625 6.125 7.78553 6.125 6.75C6.125 5.71447 6.96447 4.875 8 4.875C9.03553 4.875 9.875 5.71447 9.875 6.75C9.875 7.78553 9.03553 8.625 8 8.625Z",
    fill: "#9E9DAF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGray);
export default __webpack_public_path__ + "static/media/locationGray.049b1042c58130355b1396483c5138ac.svg";
export { ForwardRef as ReactComponent };